exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir=ltr] ._1rxhgtJc4Lwbc8jHwgeW26{padding:20px 0 10px 20px}html[dir=rtl] ._1rxhgtJc4Lwbc8jHwgeW26{padding:20px 20px 10px 0}", ""]);
// Exports
exports.locals = {
	"txp": "_1rxhgtJc4Lwbc8jHwgeW26"
};